export enum StoreStatus {
  OpenNow = 'openNow',
  ClosedNow = 'closedNow',
  ClosedToday = 'closedToday',
  OpensAt = 'opensAt',
  ClosesAt = 'closesAt',
}

export enum ColorState {
  Upcoming = 'upcoming',
  Closed = 'closed',
  Open = 'open',
}

export interface IStoreStatus {
  openingHours: string | undefined;
  closingHours: string | undefined;
  yesterdayClosingHours: string | undefined;
  yesterdayOpeningHours: string | undefined;
  dayWeek?: string;
  dateNow: Date;
}

export type DateStatus = Date | undefined;
